import React from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  makeStyles,
} from "@material-ui/core";
import FormField from "./FormField";
import DocumentUpload from "./DocumentUpload";

const useStyles = makeStyles((theme) => ({
  sectionWrapper: {
    marginBottom: theme.spacing(5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  sectionHeader: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontSize: "1.0625rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: "-0.01em",
    lineHeight: 1.3,
  },
  sectionSubtitle: {
    fontSize: "0.8125rem",
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
    lineHeight: 1.55,
  },
  divider: {
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.divider,
  },
  sectionIndex: {
    fontSize: "0.6875rem",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(0.75),
  },
}));

const FormSection = ({ section, sectionNumber, files, onFilesChange, FIELD_TYPES }) => {
  const classes = useStyles();

  return (
    <Box className={classes.sectionWrapper}>
      {/* Section Header */}
      <Box className={classes.sectionHeader}>
        <Typography className={classes.sectionIndex}>
          {String(sectionNumber).padStart(2, "0")}
        </Typography>
        <Typography variant="h6" className={classes.sectionTitle}>
          {section.sectionTitle}
        </Typography>
        {section.sectionSubtitle && (
          <Typography className={classes.sectionSubtitle}>
            {section.sectionSubtitle}
          </Typography>
        )}
      </Box>

      <Divider className={classes.divider} />

      {/* Fields */}
      <Grid container spacing={3}>
        {section.fields.map((field) => (
          <Grid
            item
            key={field.id}
            xs={field.gridSize?.xs || 12}
            sm={field.gridSize?.sm}
            md={field.gridSize?.md}
          >
            {field.type === FIELD_TYPES.FILE_UPLOAD ? (
              <DocumentUpload
                field={field}
                files={files || []}
                onFilesChange={onFilesChange}
              />
            ) : (
              <FormField field={field} FIELD_TYPES={FIELD_TYPES } />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default React.memo(FormSection);
